import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'

const INIT_STATE = fromJS(PROGRAM_DEFAULT.movieMappings)

const reducers = (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)
    return state
}
export default reducers